import { render } from "./OurReviews.vue?vue&type=template&id=e10643e4&ts=true"
import script from "./OurReviews.vue?vue&type=script&lang=ts"
export * from "./OurReviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__